import ArtistDetail from './ArtistDetailContainer';

export default ArtistDetail;
